import React, { useCallback, useMemo } from "react";
import { Tab, Menu, Label, Icon } from "semantic-ui-react";
import { TasksPaneContent } from "../TasksTabs";
import "./style.less";
import { useDispatch } from "react-redux";
import {
  setSearchTaskResults,
  searchTasksByOrderNumberOrServiceReqId
} from "../../../redux/rm-buddies/actions";

function TaskSearchResultsTab({ searchResults, onClose, orderNumberOrReqId }) {
  const dispatch = useDispatch();
  const panes = useMemo(
    () => [
      {
        menuItem: (
          <Menu.Item key="1">
            All
            <Label circular className="PENDING">
              {searchResults.length}
            </Label>
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane>
            <TasksPaneContent
              onSuccessAction={searchTasksByOrderNumberOrServiceReqId(
                orderNumberOrReqId
              )}
              tasksList={searchResults}
              taskStatus={"ALL"}
            />
          </Tab.Pane>
        )
      }
    ],
    [searchResults, orderNumberOrReqId]
  );
  const closeResults = useCallback(() => {
    dispatch(setSearchTaskResults(null));
    if (onClose) {
      onClose();
    }
  }, [dispatch, onClose]);
  return (
    <div>
      <h4 className="ResultsHeading">
        RESULTS FOR <Icon name="close" onClick={closeResults} />
      </h4>
      {searchResults && searchResults.length > 0 && (
        <h3 className="ResultsHeading">#{orderNumberOrReqId}</h3>
      )}
      <br />
      <div className="TaskSearchResultsTab">
        <Tab
          menu={{ secondary: true, pointing: true }}
          activeIndex={0}
          panes={panes}
        />
      </div>
    </div>
  );
}

export default TaskSearchResultsTab;
